import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import '../Review.css';

export default class ReviewMapVeteran extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMapVeteranOpened: false
       }
    }

    getVeteranDisplayValue = (veteran) => {
        let mappedVeteran = this.props.mapOptions.filter(option => option.label === veteran.label);
        if (mappedVeteran.length > 0)
            return mappedVeteran[0].label;
        else
            return '';
    }

    render() {
        let { allVeteranMapping } = this.props.mapVeteran;
        let {isMapVeteranOpened} = this.state;
        let noOfVeteranTypesMapped = allVeteranMapping.filter(veteranMapping => veteranMapping.column!=="").length;
        
        return (<div className="review-sub-section">
            <Row>
                <Col sm="11" md="11" className="review-sub-section-heading">Mapped {noOfVeteranTypesMapped} of {allVeteranMapping.length} values to veteran status categories</Col>
                <Col sm="1" md="1" className={isMapVeteranOpened ? 'rotate-arrow' : 'text-center'}>
                    <i className={(isMapVeteranOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}
                        onClick={() => {
                            this.setState({ isMapVeteranOpened: !isMapVeteranOpened });
                        }} />
                </Col>
            </Row>
            <Collapse isOpen={isMapVeteranOpened}>
                 <div className="mt30 mapped-review-records">
                   {allVeteranMapping.map((mappedVeteran, index) => {
                        return (<div key={index} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                            {!mappedVeteran.value || mappedVeteran.value===undefined||mappedVeteran.value===null ||mappedVeteran.value==="null"|| mappedVeteran.value==="undefined"? 
                                mappedVeteran.value="empty"
                                :
                                mappedVeteran.value
                                } Veteran type
                            </span>
                             {mappedVeteran.column!=="" &&mappedVeteran.column!==null ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>{this.getVeteranDisplayValue(mappedVeteran.column)}</span>
                            </span>: <span> left unmapped</span>}
                        </div>
                        )
                    })}
                </div> 
            </Collapse>
        </div>
                )
    }
}
